export default "__VITE_ASSET__D9Fno5PT__"